import { LabcoreErrorStatus } from "./labcore-error-status.model";
import { LabcoreLaboratoryTestsStatus } from "./labcore-laboratory-tests-status.model";
import { LabcoreOrder } from "./labcore-order.model";

export class LabcoreLaboratoryTests{
    constructor(
        public Orders?: LabcoreOrder[],
        public Status?: LabcoreLaboratoryTestsStatus,
    ){}    
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/labcore-laboratory-tests.model.ts